import { render, staticRenderFns } from "./SupplierMaterials.vue?vue&type=template&id=64e78e9d&scoped=true&"
import script from "./SupplierMaterials.vue?vue&type=script&lang=js&"
export * from "./SupplierMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e78e9d",
  null
  
)

export default component.exports